"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHOP_MAX_LEN = void 0;

require("core-js/modules/es6.array.sort");

var _mpsingle = _interopRequireDefault(require("./mpsingle"));

var _FLOTransaction = require("../flo/FLOTransaction");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CHOP_MAX_LEN = 837;
/**
 * An OIP Multipart Converter (X); converts large data into OIP Multiparts and vice versa
 * @param {string|Array.<MPSingle>} input - String data or OIP Multiparts (MPSingle)s (hint: can pass in an JSON object)
 * @class
 */

exports.CHOP_MAX_LEN = CHOP_MAX_LEN;

var MultipartX = /*#__PURE__*/function () {
  function MultipartX(input) {
    _classCallCheck(this, MultipartX);

    this.multiparts = [];

    if (typeof input === 'string') {
      if (input.length < _FLOTransaction.FLODATA_MAX_LEN) {
        return {
          success: false,
          error: 'Data does not exceed max floData length of 1040 bytes. MPX not needed.'
        };
      }

      this.fromString(input);
    } else if (Array.isArray(input)) {
      this.fromMultiparts(input);
    } else if (typeof input === 'object' && input !== null) {
      this.fromJSON(input);
    } else {
      return {
        success: false,
        error: 'Invalid input type. Must provide string, object, or array of multiparts'
      };
    }
  }
  /**
   * Splits the jsonString input into multiparts
   * @param {string} jsonString - string data that is too long to fit onto one FLO transaction
   */


  _createClass(MultipartX, [{
    key: "fromString",
    value: function fromString(jsonString) {
      var chunks = []; // ToDo:: FLODATA_MAX_LEN vs CHOP_MAX_LEN

      while (jsonString.length > CHOP_MAX_LEN) {
        chunks.push(jsonString.slice(0, CHOP_MAX_LEN));
        jsonString = jsonString.slice(CHOP_MAX_LEN);
      }

      chunks.push(jsonString);
      var max = chunks.length - 1; // We can do part, max, and data here | ref, sig, and addr are done in publisher

      var multiparts = [];

      for (var i = 0; i < chunks.length; i++) {
        var tmpObj = {};
        tmpObj.part = i;
        tmpObj.max = max;
        tmpObj.data = chunks[i];
        var mps = new _mpsingle.default(tmpObj);
        multiparts.push(mps);
      }

      this.multiparts = multiparts;
    }
    /**
     * Returns the assembled data from the multiparts
     * @return {string} assembled
     */

  }, {
    key: "toString",
    value: function toString() {
      if (!this.getMultiparts()) {
        return {
          success: false,
          error: "No mulitparts found."
        };
      }

      var datastring = '';

      var _iterator = _createForOfIteratorHelper(this.multiparts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mp = _step.value;
          datastring += mp.getData();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return datastring;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      this.fromString(JSON.stringify(json));
    }
    /**
     * Takes in an array of {MPSingle} for later method use
     * @param {Array.<MPSingle>} MPSingles - an array of multiparts {MPSingle}
     */

  }, {
    key: "fromMultiparts",
    value: function fromMultiparts(MPSingles) {
      var _iterator2 = _createForOfIteratorHelper(MPSingles),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var mp = _step2.value;

          if (!(mp instanceof _mpsingle.default)) {
            throw new Error('Input must be instanceof MPSingle');
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      MPSingles.sort(function (a, b) {
        return a.getPart() - b.getPart();
      });
      this.multiparts = MPSingles;
    }
    /**
     * Return Multiparts array
     * @return {Array.<MPSingle>} multiparts
     */

  }, {
    key: "getMultiparts",
    value: function getMultiparts() {
      return this.multiparts || [];
    }
  }]);

  return MultipartX;
}();

var _default = MultipartX;
exports.default = _default;